/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { VehicleProductAttributesModel } from '@/api/types/browse-search-types';
import type { ProductFinder } from '@/types/legacy';

type ProductFinderAttribute = {
  attribute?: string | null;
  value?: string | null;
};

export function getProductFinderAnalytics(
  productFinderData?: ProductFinder | VehicleProductAttributesModel[] | null,
  productFitmentFinderAttributes?: ProductFinderAttribute[],
) {
  let productFinderArray: ProductFinderAttribute[] | undefined;
  if (productFinderData && 'ProductFinder' in productFinderData) {
    productFinderArray = productFinderData.ProductFinder;
  }

  if (productFinderData && Array.isArray(productFinderData)) {
    productFinderArray = productFinderData.map((vehicleProductAttribute) => ({
      attribute: vehicleProductAttribute.vehicleProductAttributeName,
      value: vehicleProductAttribute.vehicleProductAttributeValue,
      subtext: vehicleProductAttribute.vehicleProductAttributeValueNote,
    }));
  }

  const productFitmentFinderData = Array.isArray(productFitmentFinderAttributes)
    ? productFitmentFinderAttributes
    : Array.isArray(productFinderArray)
      ? productFinderArray
      : undefined;

  if (Array.isArray(productFinderArray)) {
    const productFinderSpcsArray = productFinderArray.reduce<string[]>(
      (result: string[], currentValue: ProductFinderAttribute): string[] => {
        result.push(
          `${currentValue.attribute ? currentValue.attribute : ''} ${
            currentValue.value ? currentValue.value : ''
          }`,
        );
        return result;
      },
      [],
    );

    return {
      productGuide: productFinderArray.length ? 'true' : 'false',
      ...(productFinderArray.length && { productGuideSpcs: productFinderSpcsArray.join(':') }),
      ...(productFitmentFinderData?.length && {
        productFitmentFinderShown: 'True',
        productFitmentFinderInformation: productFitmentFinderData
          .map(
            (productFinderItem) =>
              `${productFinderItem.attribute ?? ''}: ${productFinderItem.value ?? ''}`,
          )
          .join(' | '),
      }),
      ...(!productFitmentFinderData?.length && { productFitmentFinderShown: 'False' }),
    };
  }

  return {
    productGuide: 'false',
    ...(productFitmentFinderData?.length && {
      productFitmentFinderShown: 'True',
      productFitmentFinderInformation: productFitmentFinderData
        .map(
          (productFinderItem) =>
            `${productFinderItem.attribute ?? ''}: ${productFinderItem.value ?? ''}`,
        )
        .join(' | '),
    }),
    ...(!productFitmentFinderData?.length && { productFitmentFinderShown: 'False' }),
  };
}
